@if(loader){
<app-loader></app-loader>
}

<p-card [header]="(isEdit===true)?'Update Order':'Create Order' ">

    <form [formGroup]="createOrderForm">

        <!-- <div class="col"> -->
        <div class="field col-12 flex justify-content-between align-items-center">

            <div class="field text-left">
                <div class="flex justify-content-start">
                    @if(isEdit){
                    <p-button label="Update" severity="info" (click)="showSaveOptionsPopup()" icon="pi pi-save"
                        size="small"></p-button>
                    }@else {
                    <p-button label="Save" pTooltip="Create Order" icon="pi pi-save" size="small"
                        (click)="showSaveOptionsPopup()"></p-button>
                    <div>
                        <p-button label="Reset" (click)="resetForm()" class="p-button-outlined ml-2 "
                            icon="pi pi-replay" severity="info" size="small"></p-button>
                    </div>
                    }
                    <p-button label="Linked Files" icon="pi pi-paperclip" size="small" (click)="openLinkedFiles()"
                        class="p-button-sm ml-2"></p-button>
                    @if(isEdit){
                    <p-button label="Move To Shipping" icon="pi pi-box" (click)="movetoShipping()" severity="info"
                        size="small" class="p-button-sm ml-2"></p-button>
                    }
                    <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" (click)="Cancel()"
                        class="p-button-sm ml-2"></p-button>
                </div>



            </div>

            <div class="flex justify-content-between align-items-center">
                <label class="block label-required font-bold">Required Field</label>

                @if (isEdit && quoation) {
                <div class="card">
                    <p-breadcrumb class="max-w-full inline-block ml-2" [model]="items"></p-breadcrumb>
                </div>
                }
            </div>


        </div>
        <!-- </div> -->

        <div class="grid mt-3">


            <div class="col">

                <div class="field text-left" style="display: flex; flex-direction: column; align-items: flex-start;">
                    <label for="website" class="label-required display">Order No</label>
                    <div style="display: flex; align-items: center;">
                        <input pInputText formControlName="OrderNo" placeholder="e.g 89098" type="text"
                            (blur)="checkOrderNumber()"
                            [readonly]="isEdit || !this.createOrderForm.controls.manualEntry.value || products.length > 0"
                            class="w-full p-inputtext-sm"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.OrderNo.errors }"
                            (keydown.enter)="focusNextInput($event)" />
                        @if (!isEdit) { <div style="margin-left: 10px;">
                            <p-checkbox formControlName="manualEntry" *ngIf="products.length == 0"
                                (onChange)="manualEntry()" [binary]="true" label="Manual Entry"
                                value="true"></p-checkbox>
                        </div>
                        }
                    </div>
                </div>

                <!-- <div class="field text-left">
                    <label class="label-required display">Supply Type</label>

                    <p-dropdown formControlName="supplyType" [options]="supplyTypes" optionLabel="description"
                        optionValue="code" placeholder="Select Supply Type" styleClass="w-full"
                        filterBy="code,description"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.supplyType.errors}">

                        <ng-template let-item pTemplate="item">
                            <span>{{item.code}} - {{item.description}}</span>
                        </ng-template>

                    </p-dropdown>
                </div> -->

                <div class="field text-left">
                    <label for="website" class="label-required display">{{unitLabel}}</label>
                    <p-autoComplete formControlName="warehouse" [dropdown]="(products.length > 0)? false : true"
                        [readonly]="products.length > 0" (onSelect)="setWarehouse($event)" [forceSelection]="true"
                        [suggestions]="filterWarehouses" (completeMethod)="filterWarehouse($event)"
                        field="warehouseName" placeholder="Search {{unitLabel}}" styleClass="w-full"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.warehouse.errors }"
                        (keydown.enter)="focusNextInput($event)">
                        <ng-template let-item pTemplate="item">
                            <span>{{item.warehouseCode}} - {{item.warehouseName}}</span>
                        </ng-template>
                    </p-autoComplete>
                </div>

                <div class="field text-left">
                    <label for="supplyType" class="label-required display">Supply Type</label>
                    <input pInputText readonly formControlName="supplyType" class="w-full p-inputtext-sm"
                        (keydown)="onKeydown($event,products)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.supplyType.errors}" />
                </div>


                <div class="field text-left flex align-items-center gap-3">

                    <div
                        *ngIf="createOrderForm.value.supplyType === 'EXPORT' || createOrderForm.value.supplyType === 'SEZ'">
                        <!-- <p-checkbox formControlName="isLUT" [binary]="true" [label]="getLUTLabel()">
                        </p-checkbox> -->
                        <p-checkbox formControlName="isLUT" [binary]="true" label="Supply under LUT (No GST)"
                            [readonly]="isOpenStatus">
                        </p-checkbox>
                    </div>



                    <div *ngIf="showRCM">
                        <p-checkbox formControlName="isRCM" [binary]="true" label="Reverse Charge (RCM)"
                            [readonly]="isOpenStatus">
                        </p-checkbox>
                        <!-- <p-checkbox formControlName="isRCM" [binary]="true" [disabled]="isOpenStatus"
                            label="Reverse Charge (RCM)">
                        </p-checkbox> -->
                    </div>

                </div>

                <div class="field text-left">
                    <div *ngIf="isExportOrSEZ()" class="field">

                        <label>Export Type</label>
                        <div class="p-2 border-round surface-100">
                            {{ getExportTypeLabel() }}
                        </div>

                    </div>

                </div>

                <div class="field text-left">
                    <label for="SalespersonCode" class="label-required display">Salesperson</label>
                    <div class="p-inputgroup p-lookup">
                        <input pInputText formControlName="salesperson" (click)="showSalesperson()" readonly
                            class="w-full p-inputtext-sm"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.salesperson.errors }"
                            (keydown.enter)="focusNextInput($event)" />
                        <button type="button" [disabled]="products.length > 0" pButton pRipple
                            (click)="showSalesperson()" icon="pi pi-search" styleClass="p-button-warn"></button>
                    </div>
                </div>



            </div>

            <div class="col">

                <div class="field text-left">
                    <!-- <div class="field text-left"> -->
                    <label for="BillToCustomerCode" class="label-required display">
                        Bill To Customer
                    </label>

                    <!-- <span *ngIf="outstandingReceivables !== 0" class="outstanding-indicator">
                                 Outstanding Receivables : {{ outstandingReceivables | currency:'INR':'symbol':'1.2-2':'en-IN' }}
                            </span> -->
                    <!-- </div> -->
                    <span class="p-fluid">
                        <div style="display: flex;">
                            <p-autoComplete formControlName="BillToCustomerCode" [readonly]="products.length > 0"
                                (onSelect)="setBillTo($event)" [suggestions]="BillTocustomerList"
                                [forceSelection]="true" (completeMethod)="autosearchBilltoCustomer($event)"
                                field="customerCode" styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.BillToCustomerCode.errors }"
                                (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.customerCode}} - {{item.customerName}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <button type="button" pButton [disabled]="products.length > 0" pRipple
                                (click)="showBillToCustomerDialog()" icon="pi pi-search" styleClass="p-button-warn"
                                style="margin-left: 10px;"></button>
                            <p-button (click)="createQuickCustomer(true)" [disabled]="products.length > 0"
                                class="p-button-outlined ml-2 " icon="pi pi-user-plus" severity="info"></p-button>
                        </div>
                    </span>
                </div>

                <div class="field text-left">
                    <label for="BillToCustomer">Bill To Customer Name</label>
                    <input pInputText readonly formControlName="BillToCustomer" class="w-full p-inputtext-sm"
                        (keydown.enter)="focusNextInput($event)" />
                </div>

                <div class="field text-left">
                    <label for="BillToCustomerAddress">Address</label>
                    <input pInputText formControlName="BillToCustomerAddress" class="w-full p-inputtext-sm"
                        (keydown)="onKeydown($event,products)" readonly />
                </div>

                <div class="field text-left">
                    <label for="orderDate" class="label-required display">Order Date</label>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="orderDate"
                            [showIcon]="true" placeholder="Select Date" [disabled]="isEdit"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.orderDate.errors }"
                            styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                    </div>
                </div>

                <div class="field text-left">
                    <label for="requestedDate" class="label-required display">Requested Date</label>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="requestedDate"
                            [showIcon]="true" placeholder="Select Date"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.requestedDate.errors }"
                            styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                    </div>
                </div>

            </div>

            <div class="col">

                <div class="field text-left">
                    <label for="ShipToCustomerCode" class="label-required display">Ship To Customer</label>
                    <span class="p-fluid">
                        <div style="display: flex;">
                            <p-autoComplete formControlName="ShipToCustomerCode" [readonly]="products.length > 0"
                                (onSelect)="setShipTo($event)" [suggestions]="ShipTocustomerList"
                                [forceSelection]="true" (completeMethod)="autosearchShiptoCustomer($event)"
                                field="customerCode" styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ShipToCustomerCode.errors }"
                                (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.customerCode}} - {{item.customerName}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <button type="button" pButton [disabled]="products.length > 0" pRipple
                                (click)="openShipToCustomerLookup()" icon="pi pi-search" styleClass="p-button-warn"
                                style="margin-left: 10px;"></button>
                            <p-button (click)="createQuickCustomer(false)" [disabled]="products.length > 0"
                                class="p-button-outlined ml-2 " icon="pi pi-user-plus" severity="info"></p-button>
                        </div>
                    </span>
                </div>

                <div class="field text-left">
                    <label for="ShipToCustomer">Ship To Customer Name</label>
                    <input pInputText formControlName="ShipToCustomer" readonly class="w-full p-inputtext-sm"
                        (keydown.enter)="focusNextInput($event)" />
                </div>

                <div class="field text-left">
                    <label for="ShipToCustomerAddress">Address</label>
                    <input pInputText formControlName="ShipToCustomerAddress" class="w-full p-inputtext-sm"
                        (keydown)="onKeydown($event, products)" readonly />
                </div>

                <div class="field text-left">
                    <label>Place of Supply (POS)</label>
                    <input pInputText formControlName="POSDisplay" readonly class="w-full" />
                </div>

                <div class="field text-left">

                    <label for="Status">Order Status</label>
                    <div>
                        <p-dropdown [options]="statusDropdown" formControlName="Status" optionLabel="label"
                            optionValue="value" styleClass="w-full">
                        </p-dropdown>
                    </div>
                </div>


            </div>

        </div>

        <p-tabView [(activeIndex)]="activeIndex">

            <p-tabPanel header="Order Lines">
                <div class="grid">

                    <!-- New Product Button -->
                    <div class="col-fixed" style="width: 150px; display: flex; align-items: center;">
                        <p-button icon="pi pi-plus" (onClick)="createQuickProduct()" [link]="true" label="New Product"
                            [size]="'small'" [style]="{'white-space':'nowrap'}">
                        </p-button>
                    </div>

                    <!-- Product Code -->
                    <div class="col" #productCodeAutoComplete>
                        <div class="field text-left" style="display: flex; align-items: center; margin-bottom: 0;">

                            <!-- Product Image -->
                            <p-image [src]="previewImage" alt="product" width="40" [preview]="true"></p-image>

                            <!-- Product Code -->
                            <div style="margin-left:10px; width:400px;">
                                <p-autoComplete #productCodeInputRef formControlName="productCode"
                                    placeholder="Search Product Code" [style]="{'width':'100%','height':'40px'}"
                                    [inputStyle]="{'width':'100%','height':'40px'}" (onSelect)="setProduct($event)"
                                    [suggestions]="filterProductList" (completeMethod)="autosearchProduct($event)"
                                    field="customerCode" (keydown.enter)="focusNextInput($event)">

                                    <ng-template let-item pTemplate="item">
                                        <span>{{item.productCode}} - {{item.productName}}</span>
                                    </ng-template>

                                </p-autoComplete>
                            </div>

                        </div>
                    </div>

                    <!-- Q-Avail -->
                    <div class="col-fixed"
                        style="width:80px; display:flex; flex-direction:column; justify-content:center; align-items:center;">

                        <p style="margin:0; font-weight:bold; font-size:14px; white-space:nowrap;">
                            Q-Avail
                        </p>

                        <p style="margin:0; font-size:14px;">
                            {{QAvail}}
                        </p>

                    </div>

                    <!-- Product Name -->
                    <div class="col">
                        <input pInputText formControlName="productDescription" readonly placeholder="Product Name"
                            class="w-full" style="height:40px;" (keydown.enter)="focusNextInput($event)" />
                    </div>

                    <!-- Qty + Add + Delete -->
                    <div class="col">
                        <div class="field text-left" style="display: flex; align-items: center; margin-bottom: 0;">

                            <span style="margin-right:10px;">
                                <input pInputText id="Qty" type="number" [formControlName]="getFormControlName()"
                                    [placeholder]="getPlaceholder()" min="0" style="height:40px;"
                                    (keydown.enter)="focusNextInput($event)" />
                            </span>

                            <p-button label="Add" (onClick)="addProduct()" [disabled]="!createOrderForm.controls.productCode.value ||
                            !createOrderForm.controls.productDescription.value ||
                            !(productCostCalculationType === 'qty'
                                ? createOrderForm.controls.productQty.value
                                : createOrderForm.controls.productWgt.value)" [raised]="true" [size]="'small'"
                                severity="info">
                            </p-button>

                            <span style="margin-left:10px;">
                                <p-button icon="pi pi-trash" (onClick)="deleteProduct()"
                                    [disabled]="selectedProduct.length === 0" [raised]="true" [size]="'small'"
                                    severity="danger">
                                </p-button>
                            </span>

                        </div>
                    </div>

                </div>
                <p-table #dt1 [value]="products" responsiveLayout="scroll" class="w-full m-5"
                    styleClass="p-datatable-sm" [rowHover]="true" [paginator]="true" [rows]="5"
                    [rowsPerPageOptions]="[5, 10, 20]" [paginator]="true" [(selection)]="selectedProduct">
                    <!-- (onEditComplete)="onProductEdit($event)"> -->
                    <ng-template pTemplate="header">
                        <tr>
                            <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                            <th>Sr No</th>
                            <th pSortableColumn="ProductCode">Code <p-sortIcon field="ProductCode"></p-sortIcon>
                            <th>Product Name </th>
                            <th>UOM </th>
                            <th></th>
                            <th>HSN/SAC</th>
                            <th>Qty</th>
                            <th>Price(₹)</th>
                            <th>Amount(₹)</th>
                            <th>Disc(%)</th>
                            <th>Net Amount(₹)</th>
                            <th>GST(%)</th>
                            <!-- <th>Weight</th> -->
                            <th>GST(₹)</th>
                            <th>Line Amount(₹)</th>
                            <th>Delivery Date</th>
                            <!-- <th>Remark</th> -->

                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-i="rowIndex">
                        <tr>
                            <td>
                                <p-tableCheckbox [value]="product"></p-tableCheckbox>
                            </td>
                            <td>{{i+1}}</td>
                            <td class="text-blue-500 underline" style="cursor: pointer;" [pEditableColumn]="product"
                                pEditableColumnField="ProductCode" (click)="viewProduct(product)">
                                {{ product.ProductCode }}
                            </td>
                            <td>{{ product.ProductDescription }}</td>
                            <td [pEditableColumn]="product" [pEditableColumnField]="'uom'">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <div class="p-inputgroup p-lookup">
                                            <input type="text" pInputText class="p-inputtext" [(ngModel)]="product.Uom"
                                                [ngModelOptions]="{ standalone: true }" [disabled]="true" />
                                            <button type="button" pButton pRipple icon="pi pi-search"
                                                styleClass="p-button-warn" (click)="showProductUom(product)"></button>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{product.Uom}}
                                    </ng-template>
                                </p-cellEditor>

                            </td>
                            <!-- <td [pEditableColumn]="product" pEditableColumnField="ProductDescription">
                                  <p-cellEditor>
                                      <ng-template pTemplate="input">
                                          <input pInputText type="text"
                                              (blur)="onProductEdit(product)"
                                              (keydown)="onKeydown($event, product)"
                                              [(ngModel)]="product.ProductDescription"
                                              [ngModelOptions]="{ standalone: true }" />
                                      </ng-template>
                                      <ng-template pTemplate="output">
                                          <span *ngIf="product.ProductDescription.length > 20; else fullText">
                                              {{ product.ProductDescription }}
                                          </span>
                                          <ng-template #fullText>
                                              {{ product.ProductDescription }}
                                          </ng-template>
                                      </ng-template>
                                  </p-cellEditor>
                              </td> -->
                            <td><span class="text-lg cursor-pointer" (click)="showSpecification(product)"><i
                                        class="pi pi-flag-fill"></i></span></td>
                            <!-- <td>{{product.Uom}}</td> -->

                            <td>{{product.HSNCode}}</td>
                            <td (click)="toggleEdit(product, 'OrderQuantity')" [pEditableColumn]="product"
                                pEditableColumnField="OrderQuantity">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="number" class="p-inputtext-sm" min="1"
                                            [(ngModel)]="product.OrderQuantity" (blur)="onProductEdit(product)"
                                            (keydown)="onKeydown($event, product)"
                                            [ngModelOptions]="{ standalone: true }" *ngIf="isEditingQuantity" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ product.OrderQuantity }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td [pEditableColumn]="product" pEditableColumnField="UnitPrice">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="number" (blur)="onProductEdit(product)"
                                            class="p-inputtext-sm" min="0" [(ngModel)]="product.UnitPrice"
                                            (keydown)="onKeydown($event, product)"
                                            [ngModelOptions]="{ standalone: true }" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        &nbsp;{{ product.UnitPrice.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2}) }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>{{product.ExtensionPrice.toLocaleString('en-IN', {
                                minimumFractionDigits: 2, maximumFractionDigits: 2}) }} </td>

                            <td [pEditableColumn]="product" pEditableColumnField="Discount">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="number" class="p-inputtext-sm" min="0" max="100"
                                            [(ngModel)]="product.Discount" (keydown)="onKeydown($event, product)"
                                            (blur)="onProductEdit(product)" [ngModelOptions]="{ standalone: true }"
                                            [disabled]="isLineDiscountDisabled()" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{product.Discount?.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2})}}%
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>{{product.NetAmount.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                maximumFractionDigits: 2})}}</td>
                            <td>{{product.GSTRate}}</td>
                            <td>{{product.SalesTax.toLocaleString('en-IN', { minimumFractionDigits:
                                2, maximumFractionDigits: 2})}}</td>
                            <td>{{product.LineTotal.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                maximumFractionDigits: 2})}}</td>

                            <!-- Weight Input -->
                            <!-- <td (click)="toggleEdit(product, 'Weight')" [pEditableColumn]="product" pEditableColumnField="Weight">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="number"
                                                class="p-inputtext-sm" min="0"
                                                [(ngModel)]="product.Weight"
                                                (blur)="onProductEdit(product)"
                                                (keydown)="onKeydown($event, product)"
                                                [ngModelOptions]="{ standalone: true }"
                                                *ngIf="isEditingWeight"/>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            &nbsp;{{ product.Weight }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td> -->

                            <!-- OrderQuantity Input -->

                            <!-- <td class="text-center"><span class="text-lg cursor-pointer"
                                    (click)="showComment(product)"><i class="pi pi-comment"></i></span></td> -->
                            <td style="display: flex; justify-content: center; max-width: 134px;">
                                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy"
                                    (blur)="onProductEdit(product)" [(ngModel)]="product.deliveryDate"
                                    (keydown)="onKeydown($event, product)" [ngModelOptions]="{ standalone: true }"
                                    [showIcon]="true" placeholder="Select Date"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.requestedDate.errors }"
                                    styleClass="w-full" (keydown.enter)="focusNextInput($event)" appendTo="body">
                                </p-calendar>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="grid" style="margin-left: 5%;">
                            <div class="col-5 md:col-8">
                                <div class="grid formgrid">

                                    <div class="field col-12 md:col-3">
                                        <label>
                                            Header Discount(₹)
                                            <i class="pi pi-info-circle"
                                                pTooltip="Header discount will be applied when line discounts are not used. Line discounts are percentage-based."
                                                tooltipPosition="top" style="margin-left:5px; cursor:pointer;">
                                            </i>
                                        </label>
                                        <input type="text" pInputText class="w-full" formControlName="DiscountAmount" />
                                    </div>

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label>Freight Charges(₹)</label>
                                        <input type="text" pInputText class="w-full" formControlName="FreightTotal">
                                    </div>

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label class="block mb-2">Rate on Freight</label>
                                        <p-dropdown [options]="gstOptions" optionLabel="label" optionValue="value"
                                            placeholder="Select GST" formControlName="RateOnFreight"
                                            styleClass="w-full">
                                        </p-dropdown>
                                    </div>

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label>GST on Freight(₹)</label>
                                        <input type="text" pInputText class="w-full" formControlName="GSTOnFreight"
                                            readonly>
                                    </div>


                                </div>
                            </div>

                            <div class="col-12 md:col-4 flex flex-column align-items-end">

                                <div class="field">
                                    CGST : ₹
                                    {{CGSTtotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>

                                <div class="field">
                                    SGST : ₹
                                    {{SGSTtotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>

                                <div class="field">
                                    IGST : ₹
                                    {{IGSTtotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>

                                <div class="field">
                                    Taxable : ₹
                                    {{Taxable.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>
                                <div class="field">
                                    Final Taxable Amount : ₹
                                    {{FinalTaxableAmt.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>
                                <div class="hr-line w-full my-2"></div>

                                <div class="flex align-items-center">
                                    <div class="mr-2">
                                        Total Qty :
                                        <span>{{weightTotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                        </span>
                                    </div>
                                    <div class="mx-2">|</div>
                                    <div>
                                        Total : ₹
                                        <span>{{orderTotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </ng-template>
                </p-table>

            </p-tabPanel>

            <p-tabPanel header="Order Details">

                <div class="grid">

                    <div class="col">

                        <!-- <div class="field text-left">
                                <label>Motor Vehical No.</label>
                                <input type="text" formControlName="MotorVehicalNo" pInputText class="w-full"
                                    (keydown.enter)="focusNextInput($event)" />
                            </div> -->

                        <div class="field text-left">
                            <label for="TermsCode">Payment Terms</label>
                            <div class="p-inputgroup p-lookup">
                                <input pInputText formControlName="TermsCode" readonly class="w-full"
                                    (keydown)="onKeydown($event,products)" />
                                <button type="button" pButton pRipple (click)="showTermsCode()" icon="pi pi-search"
                                    styleClass="p-button-warn"></button>
                            </div>
                        </div>




                        <div class="field text-left">
                            <label for="ReferenceNumber">Reference Number</label>
                            <input type="text" formControlName="ReferenceNumber" pInputText class="w-full"
                                (keydown.enter)="focusNextInput($event)" />
                        </div>

                        <div class="field text-left">
                            <label for="projectName">Project Name</label>
                            <div style="display: flex; align-items: center; gap: 0.5rem;">
                                <input pInputText formControlName="projectName" readonly placeholder="Select Project" style="width: 200px;" />
                                <p-button icon="pi pi-search" (click)="getProjectLookup()" [raised]="true" [size]="'small'" severity="info"
                                    [disabled]="canEdit"></p-button>
                                <button *ngIf="createOrderForm.get('projectName')?.value" type="button" pButton pRipple icon="pi pi-times"
                                    class="p-button-danger" severity="danger" (click)="clearProject()" title="Clear Project"
                                    [disabled]="canEdit"></button>
                            </div>
                        </div>




                        <!-- <div class="field text-left">
                                <label for="Destination">Destination</label>
                                <input type="text" formControlName="Destination" pInputText class="w-full"
                                    (keydown.enter)="focusNextInput($event)" />
                            </div> -->

                    </div>

                    <div class="col">

                        <div class="field text-left">
                            <label>Expected Dispatch Date</label>
                            <p-calendar [iconDisplay]="'input'" formControlName="ShipmentDate" dateFormat="dd/mm/yy"
                                styleClass="w-full" [showIcon]="true"
                                (keydown.enter)="focusNextInput($event)"></p-calendar>
                        </div>

                        <!-- <div class="field text-left">
                                <label>Bill Of Lading / LR-RR No.</label>
                                <input type="text" formControlName="BillOfLading" pInputText class="w-full"
                                    (keydown.enter)="focusNextInput($event)" />
                            </div> -->

                        <div class="field text-left">
                            <label>Customer PO Number</label>
                            <input type="text" formControlName="purchaseOrderNumber" pInputText class="w-full"
                                (keydown)="onKeydown($event,products)" />
                        </div>

                        <div class="field text-left">
                            <label>Customer PO Date</label>
                            <p-calendar [iconDisplay]="'input'" formControlName="CustomerPODate" dateFormat="dd/mm/yy"
                                styleClass="w-full" [showIcon]="true"
                                (keydown.enter)="focusNextInput($event)"></p-calendar>
                        </div>


                    </div>

                    <div class="col">

                        <!-- <div class="field text-left">
                                <label>Dispatch Doc No.</label>
                                <input type="text" formControlName="DispatchDocNo" pInputText class="w-full"
                                    (keydown.enter)="focusNextInput($event)" />
                            </div>
                
                            <div class="field text-left">
                                <label>Dispatch Through</label>
                                <input type="text" formControlName="DispatchThrough" pInputText class="w-full"
                                    (keydown.enter)="focusNextInput($event)" />
                            </div> -->

                        <div class="field text-left">
                            <label for="TermsOfDelivery">Terms Of Delivery</label>
                            <textarea rows="3" pInputTextarea formControlName="TermsOfDelivery"
                                class="w-full"></textarea>
                        </div>

                        <div class="field text-left">
                            <label for="deliveryNote">Delivery Note</label>
                            <textarea rows="3" pInputTextarea formControlName="deliveryNote" class="w-full"></textarea>
                        </div>

                        <!-- <div class="field text-left">
                                                                <label for="TermsCode">Terms Code</label>
                                                                <div class="p-inputgroup p-lookup">
                                                                    <input pInputText formControlName="TermsCode" readonly class="w-full p-inputtext-sm" (keydown.enter)="focusNextInput($event)"/>
                                                                    <button type="button" pButton pRipple (click)="showTermsCode()" icon="pi pi-search"
                                                                        styleClass="p-button-warn" ></button>
                                                                </div>
                                                            </div>
                                
                                                            <div class="field text-left">
                                                                <label>LR-RR No.</label>
                                                                <input type="text" formControlName="LRRRNo" pInputText class="w-full p-inputtext-sm" (keydown.enter)="focusNextInput($event)"/>
                                                            </div> -->

                    </div>

                </div>

            </p-tabPanel>

        </p-tabView>

    </form>

</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
<p-dialog [header]="isEdit ? 'Update Options' : 'Save Options'" [(visible)]="savePopupVisible" [modal]="true"
    [closable]="true" [dismissableMask]="true" (onHide)="onSavePopupHide()">

    <div class="flex gap-2">
        <p-button [label]="isEdit ? 'Update' : 'Save'" icon="pi pi-save" (click)="saveOnly()">
        </p-button>

        <p-button [label]="isEdit ? 'Update & Send' : 'Save & Send'" icon="pi pi-send" (click)="saveAndSend()">
        </p-button>
    </div>
</p-dialog>